<ng-container *ngIf="viewModel$ | async as vm">
  <section  class="is-flex items-align-center">
    <app-icon
      name="chevron-left"
      class="chevron text-24 text-grey-50 bg-grey-10 bg-grey-hover-30 is-align-start is-cursor-pointer"
      [class.disabled]="vm.report.error && vm.report.error.code === 31"
      (click)="selectPreviousTimeRange($event, vm.timeRange, vm.report)">
    </app-icon>
    <app-month-picker [value]="vm.timeRange" (valueChange)="selectDate($event, vm.report)" [minDate]="minDate" [maxDate]="vm.maxDate" class="is-fullwidth">

        <app-text class="text-section is-family-semiBold text-16 text-grey-70 bg-grey-hover-10 is-cursor-pointer is-justify-center"> {{ getMonth(vm.timeRange)}}</app-text>

    </app-month-picker>
    <app-icon
      name="chevron-right"
      class="chevron text-24 text-grey-50 bg-grey-10 bg-grey-hover-30 is-align-end is-cursor-pointer"
      [class.disabled]="noNextDate(vm.report, vm.currentDeviceReport)"
      (click)="selectNextTimeRange($event, vm.timeRange, vm.report, vm.currentDeviceReport)"
      >
    </app-icon>
  </section>

</ng-container>
